/* eslint-disable react/prop-types */
import React from 'react';
import { Button, Empty, List, Spin, Tag, Typography } from 'antd';
import moment from 'moment';

import { EnvironmentOutlined } from '@ant-design/icons';

const { Text } = Typography;

// Formata a diferença de tempo para exibição
function formatTimeDifference(timestamp) {
  const diffMinutes = moment().diff(moment(timestamp), 'minutes');
  if (diffMinutes < 60) return `${diffMinutes} min atrás`;
  if (diffMinutes < 1440) return `${Math.floor(diffMinutes / 60)}h atrás`;
  return `${Math.floor(diffMinutes / 1440)}d atrás`;
}

// Formata as coordenadas para exibição
function formatCoordinates(latitude, longitude) {
  return `Lat: ${latitude.toFixed(6)}, Lng: ${longitude.toFixed(6)}`;
}

// Lista de localizações do percurso
function LocationsList({ trackingData, loading, selectedOperator, onLocationSelect }) {
  if (loading) {
    return (
      <div className="locations-list-loading">
        <Spin size="small" />
        <Text>Carregando...</Text>
      </div>
    );
  }

  if (!trackingData || trackingData.length === 0) {
    return (
      <Empty
        description={`Nenhuma localização registrada para ${selectedOperator?.name || 'operador'}`}
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      />
    );
  }

  const sortedData = [...trackingData].sort(
    (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
  );

  return (
    <div className="locations-list">
      <Text strong>Histórico de Localizações ({sortedData.length})</Text>
      <List
        size="small"
        dataSource={sortedData}
        renderItem={(item, index) => (
          <List.Item>
            <List.Item.Meta
              avatar={<EnvironmentOutlined />}
              title={
                <div>
                  <Text strong>{item.operatorName}</Text>
                  {index === 0 && (
                    <Tag
                      color="green"
                      style={{ marginLeft: 8, borderRadius: 12, padding: '1px 8px' }}
                    >
                      Mais Recente
                    </Tag>
                  )}
                  {index === sortedData.length - 1 && (
                    <Tag
                      color="blue"
                      style={{ marginLeft: 8, borderRadius: 12, padding: '1px 8px' }}
                    >
                      Início
                    </Tag>
                  )}
                </div>
              }
              description={
                <>
                  <div>
                    <Text>{moment(item.timestamp).format('DD/MM/YYYY HH:mm:ss')}</Text>
                    <Text type="secondary"> ({formatTimeDifference(item.timestamp)})</Text>
                  </div>
                  <Button
                    type="link"
                    size="small"
                    style={{ padding: 0, height: 'auto', boxShadow: 'none' }}
                    onClick={() => onLocationSelect({ lat: item.latitude, lng: item.longitude })}
                    disabled={false}
                  >
                    <Text type="secondary" style={{ textDecoration: 'underline' }}>
                      {formatCoordinates(item.latitude, item.longitude)}
                    </Text>
                  </Button>
                </>
              }
            />
          </List.Item>
        )}
      />
    </div>
  );
}

export default LocationsList;
